import "./ShowAll.scss";
import { useEffect, useState } from "react";
import { getCategory } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InfoMessage from "../../InfoMessage/InfoMessage";

export default function ShowAll({
  active,
  id,
  setShowAllId,
  isSubcategory,
  cart,
  setCart,
  showMessage,
  setShowMessage,
}) {
  const [cookie] = useCookies(["access_token"]);
  const navigate = useNavigate();
  const [category, setCategory] = useState();
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);
  const [convertedPrices, setConvertedPrices] = useState([]);

  useEffect(() => {
    let timer;
    if (showTooltip) {
      timer = setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [showTooltip]);

  useEffect(() => {
    if (!id) return;

    !isSubcategory &&
      getCategory(id, cookie.access_token).then((res) => {
        const mealsWithPromo = res?.meals?.filter(
          (meal) => meal.promoPrice !== null
        );

        setCategory({
          ...res,
          meals: mealsWithPromo,
        });
      });
  }, [id, active, cookie.access_token, isSubcategory]);

  useEffect(() => {
    if (!Array.isArray(category?.meals) || category.meals.length === 0) {
      setConvertedPrices([]);
      return;
    }

    const prices = category.meals.map((product) =>
      product?.price ? (Number(product.price) * 1.95583).toFixed(2) : null
    );

    setConvertedPrices(prices);
  }, [category]);

  return (
    <div className="promo-show-all">
      {showMessage && <InfoMessage></InfoMessage>}
      <div className="top">
        {window.screen.width >= 767 && isSubcategory ? (
          <div
            className="back"
            onClick={() => {
              setShowAllId(null);
            }}
          >
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="8"
                viewBox="0 0 23 8"
                fill="none"
              >
                <path
                  d="M5.83337 4H22.1667"
                  stroke="#343434"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                  fill="#343434"
                />
              </svg>
            </div>

            <div className="text">
              <p>Обратно към Категориите</p>
            </div>
          </div>
        ) : (
          window.screen.width <= 767 &&
          isSubcategory && (
            <div
              className="back"
              onClick={() => {
                setShowAllId(null);
              }}
            >
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="8"
                  viewBox="0 0 23 8"
                  fill="none"
                >
                  <path
                    d="M5.83337 4H22.1667"
                    stroke="#343434"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                    fill="#343434"
                  />
                </svg>
              </div>
            </div>
          )
        )}
        <div className="title">{t(category?.name)}</div>
      </div>
      <div className="all-items">
        {category?.meals?.map((product, index) => {
          return (
            <div className="single-item" key={`${product.id}-${product.weight}`}>
              <div
                className="item-image"
                onClick={() => navigate(`/menu/product/${product.id}`)}
              >
                {product?.images[0]?.url ? (
                  <img src={product?.images[0]?.url} alt={product.name} />
                ) : (
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
                    alt={product.name}
                  />
                )}
              </div>
              <div
                className="title"
                onClick={() => navigate(`/menu/product/${product.id}`)}
              >
                <p>
                  {product.name}
                  <span> {product?.weight && `${product.weight}г`}</span>
                </p>
              </div>
              {product?.promoPrice === null ? (
                <div className="price">
                  <p>
                    {Number(product.price).toFixed(2)} {"€/"}
                    {convertedPrices.length > index &&
                    convertedPrices[index] !== null
                      ? convertedPrices[index] + t("lv")
                      : "Converting..."}
                  </p>
                </div>
              ) : (
                <div className="price">
                  <p className="new">
                    {Number(product.promoPrice).toFixed(2)} {"€/"}
                  </p>
                  <p className="old">
                    {Number(product.price).toFixed(2)} {"€/"}
                  </p>
                </div>
              )}
              <div
                className={`add-to-cart ${!category?.isActive ? "disabled" : ""}`}
              >
                {!category?.isActive && (
                  <p
                    className={`${
                      showTooltip ? "visible" : ""
                    } sushi-available`}
                  >
                    {t("sushi-available")}
                  </p>
                )}
                <button
                  disabled={!category?.isActive}
                  onMouseOver={() => !category?.isActive && setShowTooltip(true)}
                  onMouseLeave={() => !category?.isActive && setShowTooltip(false)}
                  onClick={() => {
                    if (typeof window.gtag === "function") {
                      window.gtag("event", "add_to_cart", {
                        currency: "EUR",
                        value: product?.promoPrice ?? product?.price,
                        items: [product],
                      });
                    } else {
                      console.error("gtag is not defined!");
                    }
                    setShowMessage(true);

                    const existing = cart.some(
                      (item) =>
                        item.id === product.id &&
                        item.weight === (product?.weight || product?.minWeight)
                    );

                    if (existing) {
                      setCart((currentCart) =>
                        currentCart.map((item) =>
                          item.id === product.id &&
                          item.weight ===
                            (product?.weight || product?.minWeight)
                            ? { ...item, amount: item.amount + 1 }
                            : item
                        )
                      );
                    } else {
                      setCart([
                        ...cart,
                        {
                          ...product,
                          added: [],
                          removed: [],
                          amount: 1,
                          price:
                            product?.promoPrice !== null
                              ? product?.promoPrice
                              : product?.price,
                          singlePrice:
                            product?.promoPrice !== null
                              ? product?.promoPrice
                              : product?.price,
                          isCombo: false,
                          weight: product?.weight || product?.minWeight,
                        },
                      ]);
                    }
                  }}
                >
                  {t("add")}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
